import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useApp from "../../hooks/useApp";
import CurrencyText from "../CurrencyText";
import NoticeCard from "../NoticeCard";

import "./styles.scss";

const SliderCard = ({
  cardHeading,
  cardSubHeading,
  value = 0,
  valueSuffix,
  onChange,
  step = 1,
  minValue = 0,
  maxValue = 0,
  labelSuffix,
  disabled = false,
  sliderHide = false,
  rightLabelData,
  calculatedValue = 0,
  hasCalculatedValue = false,
  cardDescription,
  noteIcon,
  noteHeading,
  noteDescription,
  noteBackgroundColor,
  hasFloatingTag,
  tagSuffix,
  hasCustomValue = false,
  customValue = 0,
  otherInfoCardHeading,
  hasOtherInfoCard = false,
  infoValueSubtext,
}) => {
  const { t } = useTranslation();
  const { isRTL } = useApp();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const handleSliderChange = (event) => {
    onChange(event.target.value);
  };

  const calculatePercentage = () => {
    return ((value - minValue) / (maxValue - minValue)) * 100;
  };

  const renderValue = ({ matchValue, value, suffix }) => {
    const numericValue = Number(value);
    const formattedValue = numericValue.toLocaleString();
    if (matchValue.includes("SAR")) {
      return (
        <div className="saudi-riyal-wrapper">
          <span className="icon-saudi_riyal"></span>
          <span>{formattedValue}</span>
        </div>
      );
    }
    const translatedSuffix = suffix ? t(`${routeName}.${suffix}`) : "";
    return (
      <>
        {formattedValue}
        {translatedSuffix && ` ${translatedSuffix}`}
      </>
    );
  };

  return (
    <div className="slider-card-container">
      {cardHeading ? (
        <div className="slider-header">
          <div className="slider-label-container">
            <div className="heading_container">
              <p className="slider-label">{t(`${routeName}.${cardHeading}`)}</p>{" "}
              {cardSubHeading && (
                <span className="slider-sub-label">
                  {t(`${routeName}.${cardSubHeading}`)}
                </span>
              )}
            </div>
            {cardDescription ? (
              <p className="slider-description">
                {t(`${routeName}.${cardDescription}`)}
              </p>
            ) : null}
          </div>
          {rightLabelData && (
            <spna className="slider-right-label">
              {t(`${routeName}.${rightLabelData?.label}`, {
                leasingPercent: rightLabelData?.value,
              })}
            </spna>
          )}
          {hasCalculatedValue ? (
            <CurrencyText
              className="slider-right-label"
              value={calculatedValue}
            />
          ) : null}
        </div>
      ) : null}
      <spna className="slider-heading">
        {renderValue({
          matchValue: t(`${routeName}.${valueSuffix}`),
          value: hasCustomValue ? customValue : value,
          suffix: valueSuffix,
        })}
      </spna>
      {!sliderHide && (
        <>
          <div className="slider-wrapper">
            <input
              type="range"
              min={minValue}
              max={maxValue}
              value={value}
              step={step}
              onChange={handleSliderChange}
              className="slider"
              style={{
                background: `linear-gradient(to ${
                  isRTL ? "left" : "right"
                }, var(${
                  disabled ? "--bs-neutral-300" : "--bs-primary-600"
                }) ${calculatePercentage()}%, var(--bs-primary-100) ${calculatePercentage()}%)`,
              }}
              disabled={disabled}
            />
            {hasFloatingTag ? (
              <div
                className="slider-value-tag"
                style={{
                  left: `${
                    isRTL ? 100 - calculatePercentage() : calculatePercentage()
                  }%`,
                  transform: "translateX(-50%)",
                }}
              >
                {renderValue({
                  matchValue: t(`${routeName}.${tagSuffix}`),
                  value: value,
                  suffix: tagSuffix,
                })}
              </div>
            ) : null}
          </div>
          <div className="range-label-wrapper">
            <span className="range-label">
              {renderValue({
                matchValue: t(`${routeName}.${labelSuffix}`),
                value: minValue,
                suffix: labelSuffix,
              })}
            </span>
            <span className="range-label">
              {renderValue({
                matchValue: t(`${routeName}.${labelSuffix}`),
                value: maxValue,
                suffix: labelSuffix,
              })}
            </span>
          </div>
        </>
      )}
      {noteHeading || noteDescription ? (
        <NoticeCard
          containerStyle={{ margin: "0px", marginTop: "36px" }}
          backgroundColor={noteBackgroundColor}
          icon={noteIcon}
          headingText={noteHeading ? `${routeName}.${noteHeading}` : ""}
          descriptionText={
            noteDescription ? `${routeName}.${noteDescription}` : ""
          }
        />
      ) : null}

      {hasOtherInfoCard ? (
        <div className="other-info-card">
          <p className="info-card-label">{t(otherInfoCardHeading)}</p>
          <div className="info-card-value-container">
            <p className="info-card-value">
              <CurrencyText value={calculatedValue} />
            </p>
            <span className="info-card-value-subtext">
              {t(infoValueSubtext)}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SliderCard;
